import { render, staticRenderFns } from "./NbnOrderManagement.vue?vue&type=template&id=37c58f44&scoped=true"
import script from "./NbnOrderManagement.vue?vue&type=script&lang=js"
export * from "./NbnOrderManagement.vue?vue&type=script&lang=js"
import style0 from "./NbnOrderManagement.vue?vue&type=style&index=0&id=37c58f44&prod&lang=scss&scoped=true"
import style1 from "./NbnOrderManagement.vue?vue&type=style&index=1&id=37c58f44&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c58f44",
  null
  
)

export default component.exports